import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
export const BoardHeader = /*#__PURE__*/ memo((param)=>{
    let { actions, ancestors, customFields, description, title } = param;
    return /*#__PURE__*/ _jsxs("header", {
        className: "flex flex-col items-start gap-3 px-3 py-4 md:px-12 md:py-0",
        "data-testid": "BOARD_HEADER",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full flex-col items-start gap-1",
                children: [
                    !!ancestors && /*#__PURE__*/ _jsx("div", {
                        className: "w-full shrink-0",
                        "data-disableselect": true,
                        children: ancestors
                    }),
                    (!!actions || !!title) && /*#__PURE__*/ _jsxs("div", {
                        className: "flex min-h-[48px] items-center gap-2",
                        children: [
                            !!title && /*#__PURE__*/ _jsx("div", {
                                className: "flex max-w-[650px] shrink",
                                "data-disableselect": true,
                                children: title
                            }),
                            !!actions && /*#__PURE__*/ _jsx("div", {
                                className: "flex shrink-0 items-center",
                                "data-disableselect": true,
                                children: actions
                            })
                        ]
                    }),
                    !!description && /*#__PURE__*/ _jsx("div", {
                        className: "contents shrink-0",
                        "data-disableselect": true,
                        children: description
                    })
                ]
            }),
            !!customFields && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                "data-disableselect": true,
                children: customFields
            })
        ]
    });
});
BoardHeader.displayName = "BoardHeader";
